<div class="card">
    <div class="card-header">
        <h2 class="card-title">Change Password</h2>
    </div>
    <div class="card-body">
        <div class="container">
            <form #form="ngForm" (submit)="submitForm(form)" novalidate>

                <div class="form-group">
                    <label class="control-label">Current Password</label>
                    <input name="oldPassword" #oldPassword="ngModel" [class.is-invalid]="oldPassword.invalid && oldPassword.touched"
                           type="password" required class="form-control" name="password" [(ngModel)]="model.oldPassword">
                    <ng-container *ngTemplateOutlet="validationErrorsTemplate; context:{ control: oldPassword }"></ng-container>
                </div>

                <div class="form-group">
                    <label class="control-label">New Password</label>
                    <input name="newPassword" #newPassword="ngModel" [class.is-invalid]="newPassword.invalid && newPassword.touched"
                           type="password" required minlength="4" class="form-control" name="newPassword"
                           appValidateEqual compare-to="confirmPassword" [(ngModel)]="model.newPassword">
                    <ng-container *ngTemplateOutlet="validationErrorsTemplate; context:{ control: newPassword }"></ng-container>
                </div>

                <div class="form-group">
                    <label class="control-label">Confirm Password</label>
                    <input name="confirmPassword" #confirmPassword="ngModel" [class.is-invalid]="confirmPassword.invalid && confirmPassword.touched"
                           type="password" required minlength="4" class="form-control" name="confirmPassword"
                           appValidateEqual compare-to="newPassword" [(ngModel)]="model.confirmPassword">
                    <ng-container *ngTemplateOutlet="validationErrorsTemplate; context:{ control: confirmPassword }"></ng-container>
                </div>

                <button class="btn btn-primary" [disabled]="form.invalid" type="submit">Submit</button>

                <div *ngIf="error" class="alert alert-danger " role="alert ">
                    {{error}}
                </div>
            </form>
        </div>
    </div>
</div>

<ng-template #validationErrorsTemplate let-ctrl="control">
    <div *ngIf="ctrl.invalid && ctrl.touched">
        <div class="alert alert-danger" *ngIf="ctrl.errors.required">
            This field is required.
        </div>
        <div class="alert alert-danger" *ngIf="ctrl.errors.minlength">
            This field should be minimum {{ctrl.errors.minlength.requiredLength}} characters.
        </div>
        <div class="alert alert-danger" *ngIf="ctrl.errors.maxlength">
            This field should be max {{ctrl.errors.maxlength.requiredLength}} characters.
        </div>
        <div class="alert alert-danger" *ngIf="ctrl.errors.pattern">
            This field's pattern: {{ctrl.errors.pattern.requiredPattern}}
        </div>
        <div class="alert alert-danger" *ngIf="ctrl.errors.modelStateError">
            {{ctrl.errors.modelStateError.error}}
        </div>
        <div class="alert alert-danger" *ngIf="ctrl.errors.appValidateEqual">
            Password mismatch.
        </div>
    </div>
</ng-template>
